import React, { Component } from 'react';
import DropdownField from '../dropdown-field/DropdownField';
import NumberSelector from '../number-selector/NumberSelector';

import FormField from '../form-field/FormField';
import './style.css';


export default class InstituteInfo extends Component {
  render() {
    const classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
    return (
      <div className={classes}>
        <div className={'form__inputs ' + this.props.styleEducation}>
          <DropdownField key='institute'
            fieldName='instituteId' title='ВУЗ/колледж'
            ref='education' optionList={this.props.instituteList}
            defaultValue={this.props.instituteId}
          />
          <FormField
            key='department' title='Факультет'
            type='text' fieldName='department'
            errorHandler={this.props.departmentHandler}
            clearFields={this.props.clearFields}
            defaultValue={this.props.department}
          />
          {/*<FormField*/}
            {/*key='year' title='Курс'*/}
            {/*type='text' fieldName='course'*/}
            {/*errorHandler={this.props.courseHandler}*/}
            {/*clearFields={this.props.clearFields}*/}
            {/*defaultValue={this.props.course}*/}
          {/*/>*/}
          <NumberSelector
            key='course'
            start={1}
            end={2}
            name='course'
            title='Курс'
            onChange={this.props.courseHandler}
            defaultValue={this.props.course}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/form-blocks/InstituteInfo.js